import React, { useState } from 'react';
import style from './dialog.module.scss';
import DragHandleIcon from '../../../../../../../assets/svg/solo-chat/drag-handle.svg';
import FlowIcon from '../../../../../../../assets/svg/solo-chat/dialog-flow.svg';
import MessaggeIcon from '../../../../../../../assets/svg/solo-chat/dialog-chat.svg';
import ActionIcon from '../../../../../../../assets/svg/solo-chat/dialog-action.svg';
import { DeleteIcon, EditIcon } from '../../../icons';
import { Content as TContent, Dialog as TDialog } from '../types';
import { ContentPreview } from './';
import { Link } from 'react-router-dom';
import { useAppAndBranchId, usePermissions } from '../../../hooks';
import { useSelector } from 'react-redux'
import lodash from 'lodash'
import { Editor } from './Editor';
import { RootState } from '../../../../../../../stateManager/store';

type Props = {
	dialog: TDialog;
	openContent: (data: TContent) => void;
	deleteDialog: (dialogId: string) => void;
};

export function Dialog(props: Props) {
	const { dialog, openContent } = props;
	const [isExpanded, setIsExpanded] = useState(false);
	const hasImage = dialog.responseType === "message" ? dialog.messages.findIndex(el => el.startsWith('image#')) !== -1 : false
	const isRandom = dialog.responseType === 'message' ? dialog.isRandom : false
	const messageCount = dialog.responseType === 'message' ? dialog.messages.length : 0

	return (
		<div id={`qna-dialog-${props.dialog.id}`} className={style.dialog}>
			<div className={style.dragHandle}>
				<img className="drag-handle" src={DragHandleIcon} alt="drag handle" />
			</div>

			<div className={style.main}>
				<Header dialog={dialog} />

				{Boolean(dialog.recognizes?.length) && (
					<>
            <Editor readOnly value={dialog.recognizes ?? ""} height="20px" />
						<div className={style.dash} />
					</>
				)}

				<div className={style.contentsList}>
					{dialog.responseType === 'service' &&
						Object.keys(dialog.actions)
							.slice(0, isExpanded ? Object.keys(dialog.actions).length : 3)
							.map((key) => {
								const action = dialog.actions[key];
								const hasImage = action.type === "message" ? action.messages.findIndex(el => el.startsWith('image#')) !== -1 : false
								const isRandom = action.type === 'message' ? action.isRandom : false
								const messageCount = action.type === 'message' ? action.messages.length : 0
								return (
									<ContentPreview
										key={key}
										data={{ ...action, dialogName: dialog.title, name: key }}
										openContent={openContent}
										name={key}
										messageCount={messageCount}
										isFlow={action.type === 'flow'}
										isService
										isRandom={isRandom}
										hasImage={hasImage}
									/>
								);
							})}
				</div>
				{dialog.responseType === 'service' &&
					Object.keys(dialog.actions).length > 3 && (
						<button
							className={style.expand}
							onClick={() => setIsExpanded(!isExpanded)}
						>
							{isExpanded ? 'Show Less' : 'Show More'}
						</button>
					)}

				{dialog.responseType !== 'service' && (
					<ContentPreview
						openContent={openContent}
						name={dialog.responseType === 'message' ? 'Message' : 'Flow'}
						messageCount={messageCount}
						hasImage={hasImage}
						isRandom={isRandom}
						isFlow={dialog.responseType === 'flow'}
						data={{
							...dialog,
							dialogName: dialog.title,
							type: dialog.responseType,
							name: dialog.responseType === 'message' ? 'Message' : 'Flow',
						} as any}
					/>
				)}
			</div>

			<Actions {...props} />
		</div>
	);
}

function Header(props: { dialog: TDialog }) {
	const { dialog } = props;

	return (
		<div className={style.header}>
			<img
				title={lodash.startCase(dialog.responseType)}
				src={
					dialog.responseType === 'service'
						? ActionIcon
						: dialog.responseType === 'message'
						? MessaggeIcon
						: FlowIcon
				}
				alt="response type"
			/>
			<p className={style.name}>{dialog.title}</p>
			{dialog.responseType === 'service' && (
				<p className={style.badge}>Service</p>
			)}
		</div>
	);
}

function Actions(props: Props) {
  const { deleteDialog, dialog: dialog } = props
  const [appId] = useAppAndBranchId()
  const [canEdit, canDelete] = usePermissions(['dialog.Edit', 'dialog.Delete']) as boolean[]
  const { selectedApp: {chatType} } = useSelector((state: RootState) => state.apps)
  return (
    <div className={style.actions}>
      { canEdit &&
        <Link to={`/apps/list/${appId}/solo/${chatType === 'genai' ? 'events' : 'qna'}/dialog/${props.dialog.id}/edit`}>
          <EditIcon width="14" height="14" stroke="#292D32" />
        </Link>
      }{canDelete &&
        <button onClick={() => deleteDialog(dialog.id)}>
          <DeleteIcon width="14" height="14" stroke="#292D32" />
        </button>
      }
    </div>
  )
}
